import { z } from "zod";

export const documentSchema = z.object({
  id: z.number(),
  file_name: z.string(),
  file_path: z.string(),
});

export type Document = z.infer<typeof documentSchema>;
